import React from 'react';
import OutlinedTextField from '../textFields/OutlinedTextField';
import SubmitButton from '../buttons/SubmitButton';
import * as formStyles from '../styles/styles.module.scss';
import * as styles from './styles/styles.module.scss';
import { FormattedMessage } from 'react-intl';

type Props = {
  applyHandler?(...args: unknown[]): unknown;
  changeHandler?(event: React.ChangeEvent<HTMLInputElement>): void;
  errorMessage?: string;
  expanded: boolean;
  isSuccess: boolean;
  removeHandler?(...args: unknown[]): unknown;
  value: string;
};

const CouponCode = ({ expanded, applyHandler, changeHandler, removeHandler, isSuccess, errorMessage, value }: Props) => {
  if (expanded) {
    const applyButtonContent = !isSuccess ? (
      <SubmitButton text={<FormattedMessage defaultMessage="Apply" />} handler={applyHandler} variant="outline" />
    ) : (
      <SubmitButton text={<FormattedMessage defaultMessage="Remove" />} handler={removeHandler} variant="outline" />
    );

    return (
      <div className={styles.container}>
        <div className={formStyles.inputGroup}>
          <OutlinedTextField
            label={<FormattedMessage defaultMessage="Coupon code" />}
            isSuccess={isSuccess}
            isDisabled={isSuccess}
            errorMessage={errorMessage}
            value={value}
            changeHandler={changeHandler}
            enterKeyHandler={applyHandler}
          />
          {applyButtonContent}
        </div>
      </div>
    );
  }

  return null;
};

CouponCode.defaultProps = {
  applyHandler: () => {},
  removeHandler: () => {}
};

export default CouponCode;
